import { makeStyles } from "@material-ui/core/styles";

const theme = (props) => {
  const styles = makeStyles(theme => ({
    paperPadding: {
      padding: 15,
    },
    tabsHolder: {
      background: 'transparent',
      color: 'blue',
      '& .MuiTab-textColorInherit': {
        opacity: 1,
      },
    },
    selectedTab: {
      background: props.color2,
      color: 'white'
    },
    customerContainer: {
      marginTop: 30,
      marginLeft: -10,
      // marginRight:-10,
      width: 'calc(100% + 20px)',
    },
    paperContainer: {
      padding: 15,
      margin: '0px 10px',
      '&:not(:last-child)': {
        marginBottom: 10,
      }
    },
    fixMargins: {
      marginTop: 15,
      width: 'calc(100% + 20px)',
    },

    //customer invoice list
    customerInvoiceListContainer: {
      marginTop: 30,
    },
    customerInvoiceListHeader: {
      padding: '15px 15px 0px 15px',
      color: '#374151',
      fontSize: 20,
      fontWeight: 400,
      '& p': {
        padding: '10px 0px',
      },
      '& .forceUppercase': {
        textTransform: 'uppercase',
        marginBottom: 20
      },
      '& span': {
        color: props.color2,
        textTransform: 'capitalize'
      }
    },
    //customer invoice detail
    customerInvoiceDetailContainer: {
      marginTop: 30,
      display: 'flex',
      justifyContent: 'flex-end',
      marginLeft: -10,
      width: 'calc(100% + 20px)',
      '& div': {
        maxWidth: 150,

      }
    },
    paginationContainer: {
      display: 'flex',
      justifyContent: 'flex-end',
      width: 'calc(100% + 20px)',
      marginLeft: -10
    },
    editSupplierConnectionAddContainer: {
      marginTop: 30,
      display: 'flex',
      justifyContent: 'flex-end',
      marginLeft: -10,
      width: 'calc(100% + 20px)',
      '& div': {
        maxWidth: 300,
      }
    },
    saveButton: {
      marginTop: 20,
      display: 'flex',
      justifyContent: 'flex-end',
      // marginLeft: -10,
      // width: 'calc(100% + 20px)',
      '& button': {
        maxWidth: 150,
      }
    },

    customerInvoiceListContainerMobile: {
      display: 'none',

    },

    '@media (max-width: 600px)': {
      customerInvoiceDetailContainer: {
        flexDirection: 'column',
        alignItems: 'flex-start',
        width: '100%',
        margin: 0,

        '& div': {
          maxWidth: '100%',
          width: '100%',
          margin: 0,
        }
      },
      saveButton: {
        justifyContent: 'center',
      },
      editSupplierConnectionAddContainer: {
        flexDirection: 'column',
        alignItems: 'flex-start',
        width: '100%',

        margin: 0,
        '& div': {

          maxWidth: '100%',
          width: '100%',
          marginBottom: 0,
        }
      },

      paginationContainer: {
        justifyContent: 'center',
        width: '100%',

      },

      customerInvoiceDetailContainer: {
        width: '100%',
        margin: 0,
      },

      customerInvoiceListContainer: {
        margin: 0,
        width: '100%',
        paddingBottom: 10,

        '& .forceUppercase': {
          textTransform: 'none',
          color: 'var(--text-strong)',
          fontSize: '1.05rem',
          fontWeight: 600,
          lineHeight: 1.25,
          marginBottom: 8,
          padding: 0,
          width: '100%',
          marginBottom: 10,
          padding: 5,

        },

      },
      customerInvoiceListHeader: {
        margin: 0,
        width: '100%',
        padding: 10,
        '& .forceUppercase': {
          textTransform: 'uppercase',
          color: 'var(--text-strong)',
          fontSize: 16,
          fontWeight: 400,
          lineHeight: 1.25,
          marginBottom: 8,
          padding: 0,
          width: '100%',
          padding: 5,

        },

      },
      fixMargins: {
        margin: 0,
        width: '100%',
      },
      customerContainer: {
        width: '100%',
        margin: 0,

      },

      customerInvoiceListContainerLaptop: {
        display: 'none',
      },


      customerInvoiceListContainerMobile: {
        display: 'block',

        width: '100%',
        marginTop: 20,

      },

    }

  }));
  return styles();
}
export default theme;

